import React, { useMemo, useState } from "react";
import Footer from "../components/Partials/Footers/HomeOne/Footer";

const ObfuscatedEmail = ({ user, domain, tld, label }) => {
  const email = useMemo(() => `${user}@${domain}.${tld}`, [user, domain, tld]);
  return (
    <a href={`mailto:${email}`} aria-label={`Email: ${label || email}`}>
      {label || email}
    </a>
  );
};

const offices = [
  {
    regionTitle: "Zyret Kosovë",
    blocks: [
      {
        title: "Redaksia",
        icon: "📰",
        rows: [
          {
            label: "E-mail:",
            node: <ObfuscatedEmail user="info" domain="balotazhi" tld="com" />,
          },
          { label: "Telefoni:", text: "+383 XX XXX XXX" },
          { label: "Mobil:", text: "+383 4X XXX XXX" },
        ],
      },
      {
        title: "Marketing",
        icon: "📢",
        rows: [
          {
            label: "E-mail:",
            node: <ObfuscatedEmail user="info" domain="balotazhi" tld="com" />,
          },
          { label: "Telefoni:", text: "+383 4X XXX XXX" },
        ],
      },
      {
        title: "Jobs",
        icon: "💼",
        rows: [
          {
            label: "E-mail:",
            node: <ObfuscatedEmail user="info" domain="balotazhi" tld="com" />,
          },
          { label: "Telefoni:", text: "+383 4X XXX XXX" },
        ],
      },
    ],
  },
];

const Contact = () => {
  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="title">INFORMACIONE KONTAKTI</h1>
            <p className="subtitle">
              Na kontaktoni për çdo pyetje, sugjerim apo bashkëpunim
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="contact-main">
        <div className="container">
          <div className="contact-layout">
            {/* Contact Information */}
            <div className="contact-info-section">
              <h2 className="section-title">Zyret Kosovë</h2>
              <div className="contact-cards">
                <div className="contact-card">
                  <div className="card-header">
                    <div className="card-address">
                      <span className="address-icon">📍</span>
                      <span>Stacioni i Autobusëve në Pejë</span>
                    </div>
                  </div>
                  <div className="departments">
                    {offices[0].blocks.map((dept, index) => (
                      <div key={index} className="department">
                        <div className="dept-header">
                          <span className="dept-icon">{dept.icon}</span>
                          <h3 className="dept-title">{dept.title}</h3>
                        </div>
                        <div className="dept-info">
                          {dept.rows.map((row, rowIndex) => (
                            <div key={rowIndex} className="info-row">
                              <span className="info-label">{row.label}</span>
                              <span className="info-value">
                                {row.node || row.text}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
